import AvatarGroup from 'components/shared/AvatarGroup/AvatarGroup';

const AssignedUsersCell = ({ data }) => {
  const assignments = Array.isArray(data?.assignments) ? data.assignments : [];

  if (assignments.length === 0) {
    return '-';
  }

  const items = assignments.map((a) => ({
    id: a.user_id,
    fullName: a.first_name + ' ' + a.last_name
  }));

  const isSingleUser = assignments.length === 1;
  const label = isSingleUser ? items[0].fullName : null;

  return (
    <div className="flex h-full w-fit items-center [&_p]:!font-normal">
      <AvatarGroup itemsToShow={5} isCompact label={label} items={items} />
    </div>
  );
};

export default AssignedUsersCell;
